import styled, { css } from 'styled-components'

export const Tools = styled.div`
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`

const containerHover = css`
  &:hover {
    &::after {
      opacity: 0.9;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: ${({ theme }) => theme.color.base.c9};
    }

    ${Tools} {
      display: grid;
    }
  }
`

type ContainerProps = {
  url: string | null
  isDragging: boolean
  isLoading: boolean
  disableHover: boolean
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  height: 100%;
  background: url(${({ url, isLoading }) => (isLoading ? null : url)})
    no-repeat center center;
  background-size: cover;

  ${({ isDragging, disableHover }) =>
    !isDragging && !disableHover && containerHover}
`

export const Tool = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`
